export default __webpack_public_path__ + "assets/images/3d129b32384df403f7361d676a69293f.svg";